import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Text, Img, Button, Line } from "components";
// import EmptyList from "../EmptyList";
import TrackHistory from "./TrackHistory";
import ItemsBox from "./ItemsBox";
import TotalBillSection from "./TotalBillSection";
import * as CUSTOM from "../../../../utils/helper/custom";
import globalRequest from "../../../../utils/global/globalRequest";
import { useDispatch } from "react-redux";
import { changeLoader } from "../../../../redux/reducers/loader";
import * as APIS from "../../../../utils/helper/Enum";
import OrderDetailGift from "./OrderDetailGift";
import MakePaymentWallet from "../MakePaymentWallet";
import { setSnackbar } from "../../../../redux/reducers/snackbar";
import OrderDetailCustomCake from "./OrderDetailCustomCake";
import CustomOrderDetailGift from "./CustomOrderDetailGift";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { CancelOrder } from "popups/CancelOrder";
import { useNavigate } from "react-router-dom";
import { changeTrigger } from "redux/reducers/trigger";
import { AdjustOrder } from "popups/AdjustOrder";
import OrderDetailProcessing from "./OrderDetailProcessing";
import PickUpPointAddress from "./PickUpPointAddress";
import MapContainer from "./DriverMap";
import { useAppFont } from "utils/helper/useAppFont";

const ReservationDetail = ({ orderData }) => {
  const { t } = useTranslation();
  const { interClass } = useAppFont();
  const details = orderData?.orderDetails?.[0]?.orderItemDetails || {};

  return (
    <div className="flex flex-row items-center justify-between mb-4">
      <div className="flex gap-4 items-start w-full">
        {/* Package Image */}
        <div className="h-[80px] w-[80px] rounded-lg overflow-hidden flex-shrink-0 bg-gray-100">
          <img
            src={details?.image || "/images/reservation_fallback.png"}
            alt={details?.packageName}
            className="w-full h-full object-cover"
            onError={(e) => { e.target.src = "/images/reservation_fallback.png"; }}
          />
        </div>

        {/* Package Info */}
        <div className="flex flex-col gap-1 flex-1">
          <div className="flex items-start justify-between w-full">
            <Text className="text-[16px] text-[#1A1A1A] font-semibold leading-[24px]"
              style={{ fontFamily: "Unbounded" }}>
              {details?.packageName || "Reservation"}
            </Text>
            <Text className="text-[16px] text-[#1A1A1A] font-semibold leading-[24px] flex items-center gap-1"
              style={{ fontFamily: "Unbounded" }}>
              <Img src="/images/Groupsar2.svg" className="w-4 h-4 inline-block" />
              {CUSTOM.setPrice(orderData?.priceDetails?.total_amount)}
            </Text>
          </div>

          {/* Date · Time · Guests */}
          <Text className={`text-[14px] text-[#727783] font-normal leading-[20px] ${interClass}`}>
            {details?.date ? CUSTOM.convertDateString(details.date, "dd MMM yyyy") : ""}
            {details?.timeSlotLabel ? " · " + details.timeSlotLabel : ""}
            {details?.guests ? " · " + details.guests + " Guests" : ""}
          </Text>
        </div>
      </div>
    </div>
  );
};

const getStatusBadge = (status) => {
  switch (status) {
    case "pending":
    case "in_progress":
      return { label: "In Progress", cls: "bg-green-50 text-green-700 border-green-200" };
    case "completed":
    case "delivered":
      return { label: "Completed",   cls: "bg-blue-50 text-blue-700 border-blue-200" };
    case "cancelled":
    case "rejected":
      return { label: "Cancelled",   cls: "bg-red-50 text-red-600 border-red-200" };
    default:
      return { label: CUSTOM.ucFirst(status || ""), cls: "bg-gray-50 text-gray-600 border-gray-200" };
  }
};

const getOrderTypeBadge = (orderType) => {
  switch (orderType) {
    case "gift":              return { label: "Gift Order",        cls: "bg-purple-50 text-purple-700 border-purple-200" };
    case "custom_cake":       return { label: "Custom Cake",       cls: "bg-pink-50 text-pink-700 border-pink-200" };
    case "custom_cake_gift":  return { label: "Custom Cake Gift",  cls: "bg-rose-50 text-rose-700 border-rose-200" };
    default:                  return { label: "Regular Order",     cls: "bg-gray-50 text-gray-600 border-gray-200" };
  }
};

// ─────────────────────────────────────────────────────────────────────────────

// ── NEW: accepts onPaymentModeChange to notify parent (MyOrderDetail) ────────
const OrderDetailDelevery = ({ orderData, setOrderDetails, onPaymentModeChange }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const [open, setOpen] = useState(false);               // kept for reference
  // const [isCustomCakePayment, setIsCustomCakePayment] = useState(false); // kept for reference
  const [isGiftPayment, setIsGiftPayment] = useState(false);
  const [showNeedHelp, setShowNeedHelp] = useState(false);
  const [isCancelOrder, setIsCancelOrder] = useState(false);
  const [isArjustOrder, setIsArjustOrder] = useState(false);
  const [showTrackModal, setShowTrackModal] = useState(false);
  const { interClass, interFamily} = useAppFont();

  // ── Notify parent whenever payment mode changes ─────────────────────────────
  useEffect(() => {
    if (onPaymentModeChange) {
      onPaymentModeChange(isGiftPayment);
    }
  }, [isGiftPayment, onPaymentModeChange]);

  /** Convert Base64 to Blob */
  const base64ToBlob = (base64, mimeType) => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mimeType });
  };

  /** download the invoice */
  const getInvoice = async (order_id) => {
    dispatch(changeLoader(true));
    try {
      let response = await globalRequest(
        `${APIS?.ORDER?.DOWNLOAD_INVOICE}/${order_id}`,
        "get",
        {},
        {},
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        const base64PDF = response?.data;
        const pdfBlob = base64ToBlob(base64PDF, "application/pdf");
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl);
        // const link = document.createElement('a');
        // link.href = pdfUrl;
        // link.setAttribute('download', 'invoice.pdf');
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
        setTimeout(() => {
          URL.revokeObjectURL(pdfUrl);
        }, 100);
      } else {
        dispatch(setSnackbar({ snackbarOpen: true, snackbarMessage: response?.message, snackbarState: "error" }));
      }
    } catch (e) {
      dispatch(setSnackbar({ snackbarOpen: true, snackbarMessage: e?.message, snackbarState: "error" }));
    }
    dispatch(changeLoader(false));
  };

  /** Reorder Api */
  const reorderApi = async (order_id) => {
    dispatch(changeLoader(true));
    try {
      let response = await globalRequest(
        `${APIS?.ORDER?.RE_ORDER}/${order_id}`,
        "post",
        {},
        {},
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        dispatch(changeTrigger("fetchCartCount"));
        setTimeout(() => {
          dispatch(changeLoader(false));
          navigate("/cart");
        }, [1000]);
      } else {
        dispatch(setSnackbar({ snackbarOpen: true, snackbarMessage: response?.message, snackbarState: "error" }));
        dispatch(changeLoader(false));
      }
    } catch (e) {
      dispatch(setSnackbar({ snackbarOpen: true, snackbarMessage: e?.message, snackbarState: "error" }));
      dispatch(changeLoader(false));
    }
  };

  /** Function to copy order Number */
  const copyText = (textToCopy) => {
    const textarea = document.createElement("textarea");
    textarea.value = textToCopy;
    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, 99999);
    document.execCommand("copy");
    document.body.removeChild(textarea);
    dispatch(setSnackbar({ snackbarOpen: true, snackbarMessage: "Text copied to clipboard", snackbarState: "success" }));
  };

  const pickupDelivered = () => {
    if (orderData?.showPickupDayAlert) {
      return (
        <div className="bg-light_blue-50 flex flex-col justify-start mt-4 p-4 rounded-lg w-full">
          <div className="flex flex-row gap-3 justify-start">
            <Img src="/images/img_info-black.svg" className="w-5 h-5 mt-0.5 flex-shrink-0" alt="info" />
            <div>
              <Text className={`${interClass} text-sm text-black-900 leading-[24px]`}>
                {t("youWillHaveToPickYourOrder")}{" "}
                <span className="font-semibold">{t("todayUppercase")}</span>{" "}
                {t("fromTheBelowPickupPointOrElseYourOrderWillGetCancelledDot")}
              </Text>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  // ── shared order-card header ─────────────────────────────────────────────────
  const renderOrderHeader = (od) => {
    if (!od) return null;
    const statusBadge   = getStatusBadge(od.status);
    const typeBadge     = getOrderTypeBadge(od.orderType);
    const itemCount     = od.orderDetails?.length || 0;
    const orderDate     = CUSTOM.convertDateString(
      CUSTOM.getDateFromStatusLog(od.orderStatusLogs, od.status),
      "MMM dd, yyyy"
    );
    const canDownload   = od.status !== "pending" && od.status !== "rejected" && od.status !== "approved";
    const canReorder    = od.status === "delivered";

    return (
      <div className="flex flex-row sm:flex-col sm:flex-wrap items-start sm:items-center justify-between gap-3 pb-4 border-b border-gray-100 mb-5">
        {/* Left – order meta */}
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
          <button
            onClick={() => copyText(od.orderNumber)}
            className={`text-[15px] font-semibold text-gray-900 ${interClass} hover:text-pink-700 transition-colors`}
          >
            {od.orderNumber}
            <span className="text-gray-500 font-normal ml-1">({itemCount} {itemCount === 1 ? "item" : "items"})</span>
          </button>

          {/* Order-type badge */}
          <span className={`inline-flex items-center gap-1 text-xs font-medium px-2.5 py-0.5 rounded-full border ${interClass} ${typeBadge.cls}`}>
            {od.orderType === "gift" || od.orderType === "custom_cake_gift" ? (
              <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M5 5a3 3 0 015-2.236A3 3 0 0114.83 6H16a2 2 0 110 4h-5V9a1 1 0 10-2 0v1H4a2 2 0 110-4h1.17C5.06 5.687 5 5.35 5 5zm4 1V5a1 1 0 10-1 1h1zm3 0a1 1 0 10-1-1v1h1z" clipRule="evenodd" />
                <path d="M9 11H3v5a2 2 0 002 2h4v-7zM11 18h4a2 2 0 002-2v-5h-6v7z" />
              </svg>
            ) : null}
            {typeBadge.label}
          </span>

          <span className={`text-sm text-gray-400 ${interClass}`}>{orderDate}</span>
        </div>

        {/* Right – status + actions */}
        <div className="flex flex-wrap items-center gap-2">
          {canReorder && (
            <button
              onClick={() => reorderApi(od.id)}
              className={`flex items-center gap-1.5 text-sm font-medium text-gray-700 hover:text-gray-900 border border-gray-300 rounded-lg px-3 py-1.5 hover:border-gray-400 transition-colors ${interClass}`}
            >
              <Img src="/images/reorder.svg" className="w-4 h-4" alt="reorder" />
              {t("reOrder")}
            </button>
          )}
          {canDownload && (
            <button
              onClick={() => getInvoice(od.id)}
              className={`flex items-center gap-1.5 text-sm font-medium text-gray-700 hover:text-gray-900 border border-gray-300 rounded-lg px-3 py-1.5 hover:border-gray-400 transition-colors ${interClass}`}
            >
              <Img src="/images/download-icon.svg" className="w-4 h-4" alt="download" />
              {t("downloadInvoice")}
            </button>
          )}
          <span className={`text-xs font-semibold px-3 py-1 rounded-full border ${interClass} ${statusBadge.cls}`}>
            {statusBadge.label}
          </span>
        </div>
      </div>
    );
  };

  // ── delivery + time info row ─────────────────────────────────────────────────
  const renderDeliveryInfo = (od) => {
    if (!od) return null;

    const addressText = od.orderType === "reservation"
      ? (od.pickupPointDetails?.name || od.branchDetails?.name || "Address not available")
      : od.deliveryMode === "delivery"
        ? (od.addressDetails?.address || "Address not available")
        : (od.pickupPointDetails?.address || "Address not available");

    return (
      <div className="mt-4 rounded-lg">
        {/* Address */}
        <div className="flex items-start gap-2 p-3 bg-gray-100 ">
          <svg
            className="w-4 h-4 text-gray-600 mt-0.5 flex-shrink-0"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          <Text className={`text-sm text-gray-900 leading-relaxed flex-1 ${interClass}`}>
            {addressText}
          </Text>
        </div>

        {od.orderType !== "reservation" && od.userDetails?.personalInformation && (
          <div className="flex items-center gap-2 p-3 bg-gray-100">
            <svg className="w-4 h-4 text-gray-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            <Text className={`text-sm text-gray-900 ${interClass}`}>
              {od.userDetails.personalInformation.first_name}{" "}
              {od.userDetails.personalInformation.last_name}
              {" · "}
              {CUSTOM.mobileWithCountryCode(od.userDetails.personalInformation.mobile_no)}
            </Text>
          </div>
        )}

        {/* Date + time slot */}
        <div className="flex items-center gap-2 p-3 bg-gray-100 ">
          <svg
            className="w-4 h-4 text-gray-600 flex-shrink-0"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <Text className={`text-sm text-gray-900 ${interClass}`}>
            {CUSTOM.changeDateFormat(od.deliveryDate, "dd/MM/yyyy")}
            {od.timeSlotDetails
              ? " " + CUSTOM.formatTimeRange(od.timeSlotDetails.openTime, od.timeSlotDetails.closeTime)
              : ""}
          </Text>
        </div>
      </div>
    );
  };

  // ── recipient details card ─────────────────
  const renderRecipientCard = (od) => {
    const gift = od?.giftDetails;
    if (!gift?.recipient_name) return null;

    const previewCard = () => {
      if (gift?.cardHtmlImage) {
        const win = window.open("", "_blank");
        win.document.write(gift.cardHtmlImage);
        win.document.close();
      } else {
        dispatch(setSnackbar({ snackbarOpen: true, snackbarMessage: "Card preview not available", snackbarState: "error" }));
      }
    };

    return (
      <div className="bg-red-50 rounded-lg px-4 py-3 mb-4 mt-4">
        <div className="flex items-center gap-3">
          <div className="h-9 w-9 rounded-full bg-[#f3d9d9] flex items-center justify-center flex-shrink-0">
            <svg className="w-5 h-5 text-[#771237]" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 12c2.7 0 4.9-2.2 4.9-4.9S14.7 2.2 12 2.2 7.1 4.4 7.1 7.1 9.3 12 12 12zm0 2.4c-3.3 0-9.8 1.6-9.8 4.9V22h19.6v-2.7c0-3.3-6.5-4.9-9.8-4.9z" />
            </svg>
          </div>
          <div className="flex flex-col">
            <Text className={`text-[15px] font-semibold text-gray-900 ${interClass}`}>
              {gift?.recipient_name}
            </Text>
            <Text className={`text-sm text-gray-600 ${interClass}`}>
              {gift?.country_code ? `${gift.country_code} ` : ""}
              {gift?.mobile_no}
              {gift?.email ? ` | ${gift.email}` : ""}
              {gift?.occasion_name ? ` | ${gift.occasion_name}` : ""}
            </Text>
          </div>
        </div>

        <Text className={`text-xs text-gray-500 mt-2 ${interClass}`}>
          {t("recipientDetails") || "Recipient Details"}
        </Text>

        {gift?.cardHtmlImage ? (
          <button
            onClick={previewCard}
            className={`mt-2 border border-gray-900 rounded-lg px-4 py-1.5 text-sm font-semibold text-gray-900 hover:bg-white transition-colors ${interClass}`}
          >
            {t("previewCard") || "Preview Card"}
          </button>
        ) : null}
      </div>
    );
  };
  // ── gift alert / place-order banner ─────────────────────────────────────────
  const renderGiftBanner = (od) => {
    if (!od) return null;
    if (od.recipientStatus === "accepted" && od.status === "pending") {
      return (
        <div className="flex items-center justify-between gap-4 bg-red-50 border border-red-100 rounded-lg px-4 py-3 mb-4">
          <div className="flex items-start gap-3 flex-1">
            <svg className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <p className={`text-sm text-gray-800 leading-relaxed ${interClass}`}>
              <span className="font-semibold text-gray-900">Please Note: </span>
              {t("yourRecipientHasConfirmedTheDetailsToConfirmThe_text")}{" "}
              {t("You have")}{" "}
              <span className="font-semibold text-red-700">30 Minutes</span>{" "}
              {t("to confirm this order otherwise it will be cancelled.")}
            </p>
          </div>
          <button
            onClick={() => setIsGiftPayment(true)}
            className={`flex-shrink-0 bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm font-semibold text-gray-800 hover:bg-gray-50 transition-colors ${interClass} whitespace-nowrap`}
          >
            {t("placeOrder2")}
          </button>
        </div>
      );
    }
    return null;
  };

  // ── card-message section ────────────────────────────────────────────────────
  const renderCardMessage = (od) => {
    let msg = "";
    if (od?.orderType === "custom_cake" || od?.orderType === "custom_cake_gift") {
      msg = od.orderDetails?.[0]?.orderItemDetails?.textOnCake || "";
    } else {
      msg = od?.cardMessage || "";
    }
    if (!msg) return null;
    return (
      <div className="mt-4 p-3 bg-amber-50 border border-amber-200 rounded-lg">
        <div className="flex items-start gap-2">
          <svg className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          <div>
            <p className={`text-xs font-semibold text-gray-900 mb-1 ${interClass}`}>{t("cardMessage")}</p>
            <p className={`text-sm text-gray-700 leading-relaxed ${interClass}`}>{msg}</p>
          </div>
        </div>
      </div>
    );
  };

  // ── order footer (total + track) ────────────────────────────────────────────
  const renderOrderFooter = (od) => {
    if (!od) return null;
    return (
      <div className="mt-5 pt-4 border-t border-gray-100 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <span className={`text-sm font-semibold text-gray-800 ${interClass}`}>Total</span>
          <span className={`text-lg font-bold text-[#771237] ${interClass} flex items-center gap-1`}>
            <Img src="/images/Groupsar.svg" className="w-4 h-4 inline-block" />
            {CUSTOM.setPrice(od.priceDetails?.total_amount)}
          </span>
        </div>
        {/* <button
          onClick={() => setShowTrackModal(true)}
          className={`px-4 py-2 text-sm font-semibold text-gray-700 border border-gray-300 rounded-full hover:border-gray-400 hover:bg-gray-50 transition-colors ${interClass}`}
        >
          {t("trackHistory") || "Track Order"}
        </button> */}
        <div className="px-5 pb-2">
          <TrackHistory orderData={od} type={od.orderType?.includes("gift") ? "gift" : od.orderType === "custom_cake" ? "custom_cake" : "regular"} />
        </div>
      </div>
    );
  };

  // ── wrapper card for all order types ────────────────────────────────────────
  const renderOrderCard = (od, extraContent = null) => {
    if (!od) return null;
    return (
      <div className="bg-[white] border border-gray-200 rounded-xl overflow-hidden shadow-sm">
        {/* Header */}
        <div className="px-5 pt-5 pb-0">
          {renderOrderHeader(od)}
        </div>

        {/* Gift banner / alerts */}
        <div className="px-5">
          {/* {renderGiftBanner(od)} */}
          {pickupDelivered()}
        </div>

        {/* QC / Processing */}
        {od.qcData?.length ? (
          <div className="px-5 pb-2">
            <OrderDetailProcessing orderData={od} />
          </div>
        ) : null}

        {/* No-show pickup point */}
        {od.deliveryMode === "delivery" && od.status === "no_show" ? (
          <div className="px-5 pb-2">
            <PickUpPointAddress data={od.branchDetails} />
          </div>
        ) : null}

        {/* Extra content per order type (gift info, custom cake info, etc.) */}
        {extraContent && <div className="px-5">{extraContent}</div>}

        {/* Product body */}
        <div className="px-5 pb-2">
          <ItemsBox orderData={od} />
        </div>

        {/* Delivery info */}
        <div className="px-5 pb-2">
          {renderDeliveryInfo(od)}
        </div>

        {(od.orderType === "gift" || od.orderType === "custom_cake_gift") ? (
          <div className="px-5 pb-2">
            {renderRecipientCard(od)}
          </div>
        ) : null}

        {/* Card message */}
        <div className="px-5 pb-2">
          {renderCardMessage(od)}
        </div>

        {/* Track history section */}
        {/* <div className="px-5 pb-2">
          <TrackHistory orderData={od} type={od.orderType?.includes("gift") ? "gift" : od.orderType === "custom_cake" ? "custom_cake" : "regular"} />
        </div> */}

        {/* Total Bill */}
        {/* <div className="px-5 pb-2">
          <TotalBillSection orderData={orderData} />
        </div> */}

        {/* Footer */}
        <div className="px-5 pb-5">
          {renderOrderFooter(od)}
        </div>
      </div>
    );
  };

  // ────────────────────────────────────────────────────────────────────────────
  // Live driver map (fastest delivery, out for delivery)
  // ────────────────────────────────────────────────────────────────────────────
  const liveMap = orderData?.orderData?.deliveryMode === "delivery" &&
    orderData?.orderData?.deliveryType === "fastest" &&
    orderData?.orderData?.status === "out_for_delivery";

  return (
    <>
      {/* Page title – hide when in payment mode */}
      {!isGiftPayment && (
        <p className={`${interClass} text-xl font-semibold text-gray-900 mb-5`}>{t("myOrders") || "Orders"}</p>
      )}

      {/* Live map */}
      {liveMap && (
        <div className="mb-5 rounded-xl overflow-hidden border border-gray-200">
          <MapContainer
            branchDetail={orderData.orderData.branchDetails}
            addressDetail={orderData.orderData.addressDetails}
            driverDetail={orderData.orderData.driverDetails}
          />
        </div>
      )}

      {orderData?.orderData?.orderType === "regular" &&
        renderOrderCard(orderData.orderData)}

      {/* ── custom cake ────────────────────────────────────────────────────── */}
      {orderData?.orderData?.orderType === "custom_cake" && (
        isGiftPayment
          ? <MakePaymentWallet orderData={orderData.orderData} setIsGiftPayment={setIsGiftPayment} setOrderDetails={setOrderDetails} />
          : renderOrderCard(
              orderData.orderData,
              <OrderDetailCustomCake setIsGiftPayment={setIsGiftPayment} orderData={orderData.orderData} />
            )
      )}

      {/* ── gift ───────────────────────────────────────────────────────────── */}
      {orderData?.orderData?.orderType === "gift" && (
        isGiftPayment
          ? <MakePaymentWallet orderData={orderData.orderData} setIsGiftPayment={setIsGiftPayment} setOrderDetails={setOrderDetails} />
          : renderOrderCard(
              orderData.orderData,
              <OrderDetailGift orderData={orderData.orderData} setIsGiftPayment={setIsGiftPayment} />
            )
      )}

      {/* ── custom cake gift ───────────────────────────────────────────────── */}
      {orderData?.orderData?.orderType === "custom_cake_gift" && (
        isGiftPayment
          ? <MakePaymentWallet orderData={orderData.orderData} setIsGiftPayment={setIsGiftPayment} setOrderDetails={setOrderDetails} />
          : renderOrderCard(
            orderData.orderData,
            <CustomOrderDetailGift orderData={orderData.orderData} setIsGiftPayment={setIsGiftPayment} />
          )
      )}

      {/* ── reservation ─────────────────────────────────────────────── */}
      {orderData?.orderData?.orderType === "reservation" &&
        renderOrderCard(
          orderData.orderData,
          <ReservationDetail orderData={orderData.orderData} />
        )
      }

      {/* ── Need Help ─────────────────────────────────────────────────────── */}
      {orderData?.orderData?.orderType && !isGiftPayment ? (
        <>
          <div className="mt-6">
            <button
              className={`text-sm ${interClass} text-pink-800 hover:text-pink-900 underline-offset-2 hover:underline transition-colors`}
              onClick={() => setShowNeedHelp(true)}
            >
              {t("needHelpOrderHeading")}
            </button>
          </div>

          <SwipeableDrawer
            anchor="right"
            open={showNeedHelp}
            onClose={() => setShowNeedHelp(false)}
            onOpen={() => setShowNeedHelp(true)}
          >
            <div className="w-full max-w-[400px] px-[30px] sm:px-4 py-8 sm:py-4 before-pink-round">
              <div className="flex flex-row gap-3 items-center justify-start w-full">
                <Img
                  className="h-6 w-6 cursor-pointer"
                  src="/images/img_close_black_900.svg"
                  alt="close"
                  onClick={() => setShowNeedHelp(false)}
                />
              </div>
              <div className="flex flex-col items-start justify-between w-full">
                <Img className="h-auto w-[200px] cursor-pointer m-auto" src="/images/customer-support.png" alt="image" />
                <Text className="text-2xl md:text-[22px] text-black-900 sm:text-xl text-center w-full mt-3" size="txtnunitoSemiBold24">
                  {t("needHelp")}
                </Text>
                <Text className="mt-3 mb-12 text-base text-gray-700 text-center w-full" size="txtnunitoRegular16Gray700">
                  {t("doYouWantToCallCustomerCare")}
                  <br />
                  {`+966 537775020`}{" "}
                  {orderData?.orderData?.orderType === "custom_cake" || orderData?.orderData?.orderType === "custom_cake_gift"
                    ? t("ForHelpOrCancelThisOrder")
                    : t("ForHelpOrCancelOrAdjustThisOrder")}
                </Text>
                <a  href="tel:966537775020" className="bg-black-900 cursor-pointer py-[11px] rounded text-base text-center text-white-A700 w-full my-2">
                  {t("callNow")}
                </a>
                <a  href="https://wa.me/966537775020" className="bg-black-900 cursor-pointer py-[11px] rounded text-base text-center text-white-A700 w-full my-2">
                  {t("ConnectNow")}
                </a>
                <div
                  className={`flex flex-row font-nunitomedium gap-5 items-center ${
                    orderData?.hideCancelButton == 0 && orderData?.hideAdjustOrderButton == 0
                      ? "justify-start"
                      : "justify-center"
                  } mt-5 w-full`}
                >
                  {orderData?.hideCancelButton == 0 ? (
                    <Button
                      className="common-pointer border border-black-900 border-solid cursor-pointer py-[11px] rounded text-base text-black-900 text-center w-[164px] xs:w-auto xs:flex-1"
                      onClick={() => { setIsCancelOrder(true); setShowNeedHelp(false); }}
                    >
                      {t("cancelOrder")}
                    </Button>
                  ) : null}
                  {orderData?.hideAdjustOrderButton == 0 ? (
                    <Button
                      className="common-pointer border border-black-900 border-solid cursor-pointer py-[11px] rounded text-base text-black-900 text-center w-[164px] xs:w-auto xs:flex-1"
                      onClick={() => { setIsArjustOrder(true); setShowNeedHelp(false); }}
                    >
                      {t("adjustOrder")}
                    </Button>
                  ) : null}
                </div>
              </div>
            </div>
          </SwipeableDrawer>
        </>
      ) : null}

      {isCancelOrder ? <CancelOrder closepopup={setIsCancelOrder} orderData={orderData} /> : null}
      {isArjustOrder ? <AdjustOrder closepopup={setIsArjustOrder} orderData={orderData} /> : null}
    </>
  );
};

export default OrderDetailDelevery;